<template>
      <div no-body class="lku-item"> 
      <b-form-row>
        <b-input-group>
            <b-input-group-prepend><label style="width:60px !important;">Filter</label></b-input-group-prepend>
            <b-form-input v-model="tblData.itemname" placeholder="Name" @keyup.13.native="refresh()" style="width:30% !important;"></b-form-input>
            <b-form-input v-model="tblData.itemcode" placeholder="Code" value="" @keyup.13.native="refresh()" class="ml-1" ></b-form-input>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
            </b-input-group-append>
        </b-input-group>
        <b-input-group>
        </b-input-group>
      </b-form-row>      
      <b-table
          class="m-0"
          ref="tblItem"
          responsive striped hover small
          style="font-size:smaller;" 
          :items="tblData.items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
          :busy="isBusy"

        >
           <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(jasa)="data">
            <span v-if="(data.item.jasa==1)">Service</span>
            <span v-else>Material</span>
          </template>
          <!-- <template v-slot:cell(qtyOrder)="data">
            {{data.item.qtyOrder || numFormat}}
          </template>
          <template v-slot:cell(qtyPO)="data">
            {{data.item.qtyPO || numFormat}}
          </template>
          <template v-slot:cell(OSUnPO)="data">
            {{data.item.OSUnPO || numFormat(0.0)}}
          </template> -->
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-item {
    td {
      padding: 0;
      a {
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import item from "../../apis/bakeryitem";
import procure from "../../apis/bakeryorder";

export default {
  data() {
    return {
      isBusy: false,
      fields: [
          {
            key: "partnumber",
            label: "Item Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "qtyOrder",
            thStyle: "width:80px",
            thClass:'text-right',
            tdClass:"text-right",
            label: "Qty. Order"
          },
          {
            key: "qtyPO",
            thStyle: "width:80px",
            thClass:'text-right',
            tdClass:"text-right",
            label: "Qty. PO"
          },
          {
            key: "OSUnPO",
            thStyle: "width:80px",
            thClass:'text-right',
            tdClass:"text-right",
            label: "Qty. OS PO"
          },
          {
            key: "unitsize",
            thStyle: "width:80px",
            thClass:"text-center",
            tdClass:"text-center",
            label: "UnitSize"
          },
          {
            key: "itemcategory",
            label: "Category",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'itemname',
        headcategory:'BREAD',
        sortDesc: false,
      },
      headCategories:[], itemCategories:[],
      updatetable:false,
      activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
      jasaMaterial : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
    };
  },
  props: {
    jasa:{type: String,default:''},
    isactive:{type: String,default:'1'},
    formdata:{
      type:Object,
      default(rawProps) {
        return {}
      }
    },  
    tgldelivery: {
      type: String,
      default: ''
    },
    pohdrkey: {
      type: String,
      default: ''
    },
    customer_group: {
      type: String,
      default: ''
    }
  },
  created: async function() {
      this.tblData.jasa=this.jasa || '';
      this.tblData.isactive=this.isactive || '';
      this.tblData.tgldelivery=this.tgldelivery || '';
      this.tblData.pohdrkey=this.pohdrkey || '';
      this.tblData.customer_group=this.customer_group || '';
      if (this.formdata.items)
      {
          for (var key in this.formdata) {
              this.tblData[key] = this.formdata[key];
          }
      }

      this.data();      
  },
  watch: {
    "tblData.page": function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.isBusy = false;
    },
    data: async function(ctx) {
      this.updatetable=!this.updatetable;
      if(this.jasa){
        this.tblData.jasa = this.jasa; 
      }
      if(this.isactive){
        this.tblData.isactive = this.isactive; 
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isBusy = true;
      const data= await procure.detailitemrequestsmry(this.tblData); 
      const { meta, list } = data;
      this.isBusy = false;
      this.tblData.total = meta.total;
      this.tblData.items = list;
      this.updatetable=!this.updatetable;
      console.log('data',data);
      // return data;
    },
    selectItem(item,index) {
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.tblData.itemcode=  '';
        this.tblData.itemname=  '';
        this.tblData.headcategory=  'BREAD';
        this.refresh();
    },    
    refresh() {
       this.data();
      this.$refs.tblItem.refresh();
    }
  }
};
</script>
